import Head from "next/head";
import { api } from "../../../../components/helpers";
import Layout from "../../../../components/layouts/DatoDocsLayout";
import { BreadCrumb } from "../../../../components/BreadCrumb";
import { ClassCGrid } from "../../../../components/grids/ClassCGrid";

export default function ClassC({ classC, user, mobileMenuIsOpen, setMobileMenu, handleToast }) {
    return <><Head><link
        rel="canonical"
        href={`https://www.covalenthq.com/docs/unified-api/class-c/`}
        key="canonical" /></Head><Layout user={user} mobileMenuIsOpen={mobileMenuIsOpen} setMobileMenu={setMobileMenu} handleToast={handleToast}>
        <article>
            <BreadCrumb title="Class C"/>
            <h1>Class C - Overview</h1>
            <h2>What are Class C endpoints?</h2>
            <p>Class C endpoints backed by Covalent's infrastructure, extend the capability and coverage of Class A and Class B endpoints. These endpoints are special because they're community-built and maintained. In the initial cohort, 10 of the top DeFi protocols are covered with support for protocol balances, historical transactions, and market data.</p>
            <ClassCGrid classC={classC} />
        </article></Layout></>;
}

export async function getStaticProps() {
    const classC = await api.get_all_classC();
    return {
        props: {
            classC: classC,
            component: "ClassC"
        },
    };
}
